import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import TopBar from "./TopBar";

const useStyles = makeStyles((theme) => ({
  MainComponent: {
    minHeight: "100vh",
    background: "transparent",
    position: "relative",
  },
  loginLayoutBox: {
    width: "100%",
    minHeight: "100vh",
    position: "relative",
  },
  contentContainer: {
    minHeight: "100vh",
    position: "relative",
    display: "flex",
    flexDirection: "column",
  },
  MainLayout: {
    flex: 1,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function LoginLayout({ children }) {
  const classes = useStyles();
  
  return (
    <Box className={classes.MainComponent}>
      <TopBar />
      <Box className={classes.loginLayoutBox}>
        <Box className={classes.contentContainer}>
          <Box className={classes.MainLayout}>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
